import { SF } from '@/storefront';


    export interface IReplaceOptions {
        [key: string]: number | string;
    }

    let _missingTranslationTimeout:number;
    let _missingTranslationList: { [key: string]: string } = {};

    /**
     * note: viewableContent should be html encoded BEFORE passing here.  attributes should NOT.
     * ideally, this could be use to recursively wrap a text block that has multiple translations,
     * i.e. a content block and its title.
     * this would be achieved (theoretically) by calling this twice.  first, with the main content and then calling
     * again with the result of the first call as the content and applying an editable wrapper for the title context.
     * so the result we may get is something like this:
     *      <div note="editableWrapper for title">
     *          <div note="editableWrapper for content">
     *              <div title="title" note="content-generated div with title">
     *                  content
     *              </div>
     *          </div>
     *      </div>
     * a doubly wrapped content is useful because it will show up twice in the context menu to allow editing each item.
     *
     * @param {string} viewableContent
     * @param {object} cmAttributes
     * @param {object} divWrapperAttributes
     * @returns {string}
     */
    function editableWrapper(viewableContent: string, cmAttributes: { [key: string]: string }, divWrapperAttributes: { [key: string]: string }): string {
        let divHtml = '<div ';
        if (divWrapperAttributes !== null && typeof divWrapperAttributes == 'object') {
            Object.keys(divWrapperAttributes).forEach(key => {
                divHtml += ' ' + key + '="' + divWrapperAttributes[key].replace('"', '&quot;') + '"';
            });
        }
        if ((cmAttributes !== null) && typeof cmAttributes == 'object') {
            Object.keys(cmAttributes).forEach(key => {
                divHtml += ' data-cm-' + key + '="' + cmAttributes[key].replace('"', '&quot;') + '"';
            });
            divHtml += ' data-cm-type="editable"';
        }
        return divHtml + '>' + viewableContent + '</div>';
    }

    function logMissingTranslation(phrase: string, defaultTranslation: string): void {
        if (_missingTranslationTimeout) {
            clearTimeout(_missingTranslationTimeout);
        }

        // add the one translation that we actually came here for.
        _missingTranslationList[phrase] = defaultTranslation;
        _missingTranslationTimeout = window.setTimeout(sendMissingTranslationsToServer, 500);
    }

    function sendMissingTranslationsToServer(): void {

    }

    SF.trWithCount = (count: number, phraseKey: string, replacements: IReplaceOptions, defaultTranslation: string, enableTranslationWrapper: boolean, defaultPluralTranslation?: string, encodeBreakAsHtml?: boolean): string => {

        let pluralKeyPhrase: string = phraseKey;
        if (count > 1) {
            pluralKeyPhrase += '_PLURAL';
            if (defaultPluralTranslation && defaultPluralTranslation.length > 0) {
                defaultTranslation = defaultPluralTranslation;
            }
        }

        replacements['COUNT'] = count;
        return SF.tr(pluralKeyPhrase, replacements, defaultTranslation, enableTranslationWrapper, encodeBreakAsHtml);
    };

    SF.getQueryParam = (param:string) : string|null => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has(param)) {
            return searchParams.get(param);
        }
        return null;
    } ;

    /**
     * Function that takes care of accessing the SFLanguage object.
     * Example Usage: SF.tr('CART_MULTIPLE_ITEMS_IN_CART', {COUNT: 10}, 'There are {{COUNT}} items in your cart');
     *
     */
    SF.tr = (phraseKey: string, replacements?: IReplaceOptions | string, defaultTranslation?: string | boolean, enableTranslationWrapper?: boolean, encodeBreakAsHtml?: boolean, doNotLogIfMissing?: boolean): string => {
        let trans: string;
        let viewableContent: string;
        const langKey = phraseKey.toLowerCase().replace(/[\\"'\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, '');

        // support for omitting the "replacements" arg -- do not support this for other args.
        if ((typeof (replacements) === 'string') && (typeof (defaultTranslation) !== 'string')) {
            enableTranslationWrapper = (defaultTranslation as any);
            defaultTranslation = (replacements as any);
            replacements = undefined;
        }

        if (typeof defaultTranslation !== 'string') {
            defaultTranslation = phraseKey;
        }

        if (window.SFLanguage && window.SFLanguage.hasOwnProperty(langKey)) {
            trans = window.SFLanguage[langKey];
        } else {
            if (SF.showTranslate && !doNotLogIfMissing) {
                // missing translations for dynamic keys should never be logged!  they should not be in the lexicon.
                logMissingTranslation(langKey, defaultTranslation as string);
            }
            trans = defaultTranslation as string;
        }

        // we have a translation, proceed with replacing arguments
        Object.keys(replacements || {}).forEach(replace => {
                // note: need "?:" to make sure we do not replace $1 and $2 with captured (delimiter) strings.
                trans = trans.replace(new RegExp('(?:@@|\\{\\{|\\[)' + replace + '(?:@@|\\}\\}|\\])', 'g'),
                    (replacements as any)[replace] as string);
        });

        // use the encodeBreakAsHtml flag to determine if we should be applying the <br> .. i.e. title text does not want
        if (typeof encodeBreakAsHtml === 'undefined' || encodeBreakAsHtml) {
            viewableContent = trans.replace(/\\n/g, '<br />');
        } else {
            viewableContent = trans.replace(/\\n/g, '\n');
        }

        if (enableTranslationWrapper && SF.showTranslate) {
            viewableContent = editableWrapper(
                viewableContent, {
                    'class': 'TranslationEditor', // 'editable' class name.
                    label: 'Change Caption', // context menu caption.
                    prefix: 'JAVASCRIPT', // language prefix
                    key: langKey, // language key
                    'default': defaultTranslation // language default content.
                }, {
                    'class': 'editableTranslation',
                    title: trans.replace(/[<>"']/g, '_') // prevent characters that will destroy the title attribute.
                }
            );
        }

        return viewableContent;
    };

